import React from "react";
import { Widget } from "./analyticsState";
import ChartRenderer from "./ChartRenderer";

interface Props {
  widget: Widget;
  isSelected: boolean;
  isDark: boolean;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

const WidgetCard: React.FC<Props> = ({ widget, isSelected, isDark, onSelect, onDelete }) => {
  const { showBorder, borderColor, borderWidth, backgroundColor } = widget.uiConfig.global;
  
  const cardStyle: React.CSSProperties = {
    backgroundColor: backgroundColor || (isDark ? "#1E1E1E" : "#FFFFFF"),
    ...(showBorder ? { border: `${borderWidth || 1}px solid ${borderColor || "#DADCE0"}` } : {})
  };

  return (
    <div
      className={`ca-widget-card${isSelected ? " ca-widget-selected" : ""}`}
      style={cardStyle}
      onClick={(e) => { e.stopPropagation(); onSelect(widget.id); }}
    >
      <div className="ca-widget-header">
        <h4 className="ca-widget-title">{widget.title}</h4>
        <div className="ca-widget-actions">
          <button
            className="ca-widget-action-btn"
            title="Delete widget"
            onClick={(e) => { e.stopPropagation(); onDelete(widget.id); }}
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      </div>
      <div className="ca-widget-body">
        <ChartRenderer widget={widget} isDark={isDark} />
      </div>
    </div>
  );
};

export default WidgetCard;
